import { render, staticRenderFns } from "./DetalleIvaRetenido.vue?vue&type=template&id=44a42aa0"
import script from "./DetalleIvaRetenido.vue?vue&type=script&lang=js"
export * from "./DetalleIvaRetenido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44a42aa0')) {
      api.createRecord('44a42aa0', component.options)
    } else {
      api.reload('44a42aa0', component.options)
    }
    module.hot.accept("./DetalleIvaRetenido.vue?vue&type=template&id=44a42aa0", function () {
      api.rerender('44a42aa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/DetalleIvaRetenido.vue"
export default component.exports